export const sidebarUiTokens = {
  workspacePanelPaddingX: 'px-2',
  panelPaddingY: 'py-3',
  headerRowHeight: 'h-9',
  sectionDivider: 'h-px w-full bg-border',
  headerActionButton: 'h-8 w-8',
  headerActionIcon: 'h-4 w-4',
  workspaceTextIndent: 'pl-2',
} as const
